import React, {useState, useEffect} from 'react'
import {BiMenuAltRight} from "react-icons/bi"
import {AiOutlineClose} from "react-icons/ai"
import classes from './NewHeader_dev.module.scss'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom' 

const NewHeader = () => {
    const [ menuOpen, setMenuOpen] = useState(false);
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: undefined,
    });

    useEffect(() => {
      const handleResize= () => {
          setSize({
              width: window.innerWidth,
              height:window.innerHeight
          })
      }
      window.addEventListener("resize",handleResize)

      return () => window.removeEventListener("resize", handleResize)
    }, []);

    useEffect(() => {
      if (size.width >767 && menuOpen) {
          setMenuOpen(false)
      }
    }, [size.width, menuOpen]);
    
    const menuToggleHandler = () => {
        setMenuOpen((p)=>!p)
    }

    const location = useLocation();
    useEffect(() => {
        //alert(location.pathname);
    }, [location]);
  return (
      <header className={classes.header}>
          <div className={classes.header__content}>
            <Link to="/" className={classes.header__content__logo}>
                <img src="img/logo_origin.png" id="img_001" alt="logo_big" />
            </Link>
            <nav className={`${classes.header__content__nav} ${
                menuOpen && size.width <768 ? classes.isMenu : ""
            }`}
            >
                <ul>
                    <li>
                        <Link to="/" className={location.pathname.toLowerCase().indexOf('home') > -1 ? classes.online : classes.outline} onClick={menuToggleHandler} >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/AboutUs" className={location.pathname.toLowerCase().indexOf('aboutus') > -1 ? classes.online : classes.outline} onClick={menuToggleHandler} >
                            About Us
                        </Link>
                    </li>                    
                    <li>
                        <Link to="/Product" className={location.pathname.toLowerCase().indexOf('product') > -1 ? classes.online : classes.outline} onClick={menuToggleHandler} >
                            Products
                        </Link>
                    </li>
                    <li>
                        <Link to="/Board" className={location.pathname.toLowerCase().indexOf('board') > -1 ? classes.online : classes.outline} onClick={menuToggleHandler} >
                            Board
                        </Link>
                    </li>      
                    <li>
                        <Link to="/Download" className={location.pathname.toLowerCase().indexOf('download') > -1 ? classes.online : classes.outline} onClick={menuToggleHandler} >
                            Donwload
                        </Link>
                    </li>               
                    <li>
                        <Link to="/Home_en" className={classes.outline} onClick={menuToggleHandler} >
                            <img src="img/flag_usa.png" alt="flag" />
                        </Link>
                    </li>
                </ul>
            </nav>
            <div className={classes.header__content__toggle}>
                {!menuOpen ? (
                    <BiMenuAltRight onClick= {menuToggleHandler} />
                ) : (
                    <AiOutlineClose style={{color:"#fff"}} onClick= {menuToggleHandler} />
                )}
            </div>
          </div>
      </header>
  )
}

export default NewHeader